export type LoadableValue = {
    state: 'loading' | 'hasData' | 'hasError';
    data?: any;
    error?: any;
};

export enum TFirmwareUptodateness {
    /** The mac doesn't exist */
    UNKNOWN_MAC = 0,
    /** The device never announced so we don't know its version */
    UNKNOWN_VERSION = 1,
    /** The device is downloading or booting a new fw version */
    UPDATING = 2,
    /** The version is too old for installation purposes */
    TOOOLD = 3,
    /** The version is new enough for installation purposes but not necessarily the globally wanted version for day-to-day operation */
    NEWENOUGH = 4,
}

export enum ControlType {
    PILOTE = 'fil_pilote',
    RELAIS = 'relais',
}

export enum ConnectionType {
    LTE = 'lte',
    WIFI = 'wifi',
}

export enum DeepomaticTaskGroups {
    PDL = 'pdl',
    ELECTRICAL_PANEL_BEFORE = 'tableau_electrique_avant',
    ELECTRICAL_PANEL_AFTER = 'tableau_electrique_apres',
    CUSTOMER_APP = 'application_client',
    WIRING = 'cablage',
    DBOX_AND_HEATER = 'radiateur',
    BUTTON_OR_SCREEN = 'bouton_ecran_numerique',
    HEATER_LABEL = 'fiche_signaletique',
}

export enum DeepomaticTasksWithOCR {
    LABEL_BRAND = 'fiche_marque_radiateur',
    LABEL_MODEL = 'fiche_ref_radiateur',
    DIGITAL_SCREEN_TEMPERATURE = 'ecran_numerique_temperature',
    DBOX_RELATIVE_POSITION = 'position_DBox',
}

export type TRequestParams = {
    status?: boolean;
    announce?: boolean;
    crashDumpRead?: boolean;
    crashDumpClear?: boolean;
    modemInfo?: boolean;
    terminalEnable?: boolean;
    terminalDisable?: boolean;
    publicKey?: boolean;
    privateKeyRenew?: boolean;
    meshId?: boolean;
    calibParams?: boolean;
    timezone?: boolean;
    ramDump?: boolean;
    eventSelfHeat?: boolean;
    eventSelfTest?: boolean;
    eventMovement?: boolean;
    tasksStatistics?: boolean;
    eventSafety?: boolean;
    ssid?: boolean;
    eventInterpol?: boolean;
    eventHeatSpeed?: boolean;
    selfTest?: boolean;
    eventTs3Battery?: boolean;
    eventTs3FwVer?: boolean;
};
